import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import './plugins/element.js'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import Echarts from 'echarts'
Vue.use(Echarts);

import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard)

import '@/icons'
import pager from '@/components/pager.vue';
import userInfo from '@/components/user-Info.vue';
import AddressSelect from '@/components/address';
Vue.component('vue-pager', pager);
Vue.component('user-info', userInfo);
Vue.component('address-select', AddressSelect);




import Common from '@/script/common.js';
import store from './store';
Common.$router = router;
Common.$element = ElementUI;
Vue.prototype.$common = Common;
Vue.prototype.$echarts = Echarts;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
